module.exports = "/fonts/vendor/material-icons/iconmaterial-icons-outlined.woff?f882956fd323fd322f31c0665e000772";